export const defineBrowser = () => {
  const isEdgeBrowser =
    window.navigator.userAgent.includes("Edg") ||
    window.navigator.userAgent.includes("Edge");

  return isEdgeBrowser ? "new-password" : "off";
};
